<template>
  <div>
    <calls-report-table
      ref="table"
      :url="indexUrl"
      :filter-list="filters"
      :download-url="downloadUrl"
      :can-download="canDownload"
    ></calls-report-table>
  </div>
</template>

<script>
import CallsReportTable from '../../components/reports/calls/table';
import eventBus from '../../event-bus';

export default {
  components: {
    CallsReportTable,
  },

  props: {
    indexUrl: String,
    filters: Array,
    downloadUrl: String,
    canDownload: Boolean,
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.table.refresh();
    },
  },

  created() {
    eventBus.$on('refresh-calls-report-table', this.refresh);
  },

  beforeDestroy() {
    eventBus.$off('refresh-calls-report-table', this.refresh);
  }
}
</script>
